export default {"src":"/_next/static/media/attention.528b638d.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};